import * as React from "react";

export function MoneyCoin(props) {
  return (
    <svg
      width={37}
      height={37}
      viewBox="0 0 37 37"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g clipPath="url(#clip0_29_64)" fill="#FAFAFA">
        <path d="M18.226 5.48c-7.04 0-12.747 5.707-12.747 12.747s5.707 12.747 12.747 12.747 12.748-5.707 12.748-12.747c-.008-7.037-5.71-12.74-12.748-12.748zm.408 11.933c1.44.72 3.235 1.617 3.235 4.456a3.64 3.64 0 01-2.732 3.513v1.04a.91.91 0 01-1.821 0v-1.04a3.64 3.64 0 01-2.732-3.513.91.91 0 111.821 0 1.821 1.821 0 003.643 0c0-1.714-.886-2.157-2.229-2.828-1.44-.72-3.235-1.617-3.235-4.456a3.639 3.639 0 012.732-3.513v-1.04a.91.91 0 111.821 0v1.04a3.639 3.639 0 012.732 3.513.91.91 0 01-1.821 0 1.821 1.821 0 10-3.643 0c0 1.713.886 2.157 2.229 2.828z" />
        <path d="M18.227.016C8.169.016.017 8.17.017 18.226c0 10.058 8.152 18.212 18.21 18.212 10.057 0 18.21-8.154 18.21-18.211C36.426 8.174 28.28.027 18.227.017zm0 32.78c-8.046 0-14.569-6.523-14.569-14.57 0-8.045 6.523-14.568 14.569-14.568 8.046 0 14.568 6.523 14.568 14.569-.01 8.042-6.526 14.559-14.568 14.568z" />
      </g>
      <defs>
        <clipPath id="clip0_29_64">
          <path
            fill="#fff"
            transform="translate(.016 .016)"
            d="M0 0H36.4213V36.4213H0z"
          />
        </clipPath>
      </defs>
    </svg>
  );
}
